import { useEffect, useRef } from 'react';
import { UsersItem } from './UsersItem/UsersItem';
import styles from './UsersTable.module.scss';
import cx from 'classnames';
import { BlockWrapperWithSpinner, Text } from 'components';
import { getUsersLoading } from 'store/users/selectors';
import { usersActions } from 'store/users/slice';
import { useDispatch, useSelector } from 'store/utils';
import { User } from 'types';

type Props = {
  users: User[];
};

export const UsersTable = ({ users }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();

  const isLoading = useSelector(getUsersLoading);

  useEffect(() => {
    if (!isLoading) {
      dispatch(usersActions.getUsers());
    }
  }, []);

  if (isLoading)
    return (
      <div className={styles.container}>
        <BlockWrapperWithSpinner isLoading={true} />
      </div>
    );

  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.header}>
        <div className={cx(styles.cell, styles.name)}>
          <Text className={styles.cellText} type="overline">
            Name
          </Text>
        </div>
        <div className={cx(styles.cell, styles.email)}>
          <Text className={styles.cellText} type="overline">
            Login Email
          </Text>
        </div>
        <div className={cx(styles.cell, styles.role)}>
          <Text className={styles.cellText} type="overline">
            User Role
          </Text>
        </div>
        <div className={cx(styles.cell, styles.status)}>
          <Text className={styles.cellText} type="overline">
            Status
          </Text>
        </div>
      </div>
      <div className={styles.body}>
        {users.map((user) => (
          <UsersItem key={user.id} user={user} tableRef={ref} />
        ))}
      </div>
    </div>
  );
};
